import React from 'react';

import Shimmer from 'components/Shimmer';

import { AirTable, Container, Price, Border, Content } from '../FlightsCompare/styles';
import { Airline, StopTable, Header } from './styles';

const LoadingFlightsCompare = () => (
  <>
    <Container>
      <Header>
        <Shimmer>Precios per airlineas</Shimmer>
      </Header>
      <Content>
        <StopTable>
          <table>
            <thead>
              <tr>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {['Directo', '1 escala'].map((item, idx) => (
                <tr key={idx}>
                  <td>
                    <span>
                      <Shimmer>{item}</Shimmer>
                    </span>
                    <Border />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </StopTable>
        <AirTable>
          <table>
            <thead>
              <tr>
                {Number(3)
                  .toArray()
                  .map((k) => (
                    <Airline key={k}>
                      <Airline.Div>
                        <Airline.Logo />
                        <Airline.Text></Airline.Text>
                      </Airline.Div>
                      <Border />
                    </Airline>
                  ))}
              </tr>
            </thead>
            <tbody>
              {Number(2)
                .toArray()
                .map((idx) => (
                  <tr key={idx}>
                    {Number(3)
                      .toArray()
                      .map((k) => (
                        <td key={`${idx}-${k}`}>
                          <span>
                            <Price>
                              <Shimmer>$99.999</Shimmer>
                            </Price>
                            <Border />
                          </span>
                        </td>
                      ))}
                  </tr>
                ))}
            </tbody>
          </table>
        </AirTable>
      </Content>
    </Container>
  </>
);
export default LoadingFlightsCompare;
